import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-truncate"
}

import MyFilterPreview from "~/cabinet/vue/interface/filter/MyFilterPreview.vue";
import {FilterActionDescription} from "~/cabinet/ts/data/events/ActionDescription";
import {useActionBlockOutputProps} from "~/cabinet/vue/client/events/action/types/useActionBlockOutput";
import {computed} from "vue";


const __default__ = {
    name: "FilterBlockOutput"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useActionBlockOutputProps<FilterActionDescription>()
},
  setup(__props) {

let props = __props;

let filters = computed(() => {
    return props.actionDescription.getFilters(props.contentVariables);
});



return (_ctx: any,_cache: any) => {
  return (_unref(props).params.descr)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(props).params.descr), 1))
    : (_openBlock(), _createBlock(MyFilterPreview, {
        key: 1,
        "filters-data": _unref(filters),
        value: _unref(props).params.filterValues,
        editable: false,
        "empty-filters-string": "Фильтры не заданы",
        style: {"padding":"0","background":"none","margin-top":"-6px"}
      }, null, 8, ["filters-data", "value"]))
}
}

})